import React, { useState } from "react";

import { Box, TextField, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

const StringListEditor: React.FC<{ value: string[]; onChange: (list: string[]) => void }> = ({ value, onChange }) => {
    const [newItem, setNewItem] = useState<string>("");
    const { formatMessage } = useIntl();

    const handleAdd = () => {
        if (newItem.trim()) {
            const updatedList = [...value, newItem.trim()];
            setNewItem("");
            onChange?.(updatedList);
        }
    };

    const handleDelete = (index: number) => {
        const updatedList = value.filter((_, i) => i !== index);
        onChange?.(updatedList);
    };

    return (
        <Box
            sx={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "4px",
            }}
        >
            <List dense sx={{ padding: 0 }}>
                {value.map((item, index) => (
                    <ListItem
                        key={index}
                        secondaryAction={null}
                        dense
                        sx={{ padding: "2px", marginBottom: "2px", backgroundColor: "grey.200" }}
                    >
                        <ListItemText
                            primary={item}
                            sx={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                            }}
                        />
                        <Box display="flex" alignItems="center" ml={1}>
                            <IconButton onClick={() => handleDelete(index)} size="small">
                                <FontAwesomeIcon icon={faTrash} />
                            </IconButton>
                        </Box>
                    </ListItem>
                ))}
            </List>
            <Box display="flex" gap={1} mt="2px">
                <TextField
                    value={newItem}
                    onChange={(e) => setNewItem(e.target.value)}
                    placeholder={formatMessage({ id: "list_field_add_new", defaultMessage: "Add new" })}
                    size="small"
                    fullWidth
                />
                <IconButton onClick={handleAdd} size="small" color="primary">
                    <FontAwesomeIcon icon={faPlus} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default StringListEditor;
